module.exports = __webpack_public_path__ + "img/banner-home-5-mobile.6754cf90.jpg";